import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
interface PersonModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (person: any) => void;
}
export function PersonModal({
  isOpen,
  onClose,
  onSave
}: PersonModalProps) {
  const [formData, setFormData] = useState({
    name: '',
    role: 'Witness',
    contact: '',
    notes: ''
  });
  const handleSubmit = () => {
    onSave(formData);
    onClose();
    setFormData({
      name: '',
      role: 'Witness',
      contact: '',
      notes: ''
    });
  };
  return <Modal isOpen={isOpen} onClose={onClose} title="Add Person" footer={<div className="flex justify-end space-x-3" data-id="element-303">
          <Button variant="ghost" onClick={onClose} data-id="element-304">
            Cancel
          </Button>
          <Button onClick={handleSubmit} data-id="element-305">Save Person</Button>
        </div>} data-id="element-302">
      <div className="space-y-4" data-id="element-306">
        <Input label="Full Name" placeholder="e.g., John Smith" value={formData.name} onChange={e => setFormData({
        ...formData,
        name: e.target.value
      })} data-id="element-307" />

        <div data-id="element-308">
          <label className="block text-sm font-medium text-text-primary mb-1.5" data-id="element-309">
            Role / Relationship
          </label>
          <select className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-purple" value={formData.role} onChange={e => setFormData({
          ...formData,
          role: e.target.value
        })} data-id="element-310">
            <option value="Witness" data-id="element-311">Witness</option>
            <option value="Involved Party" data-id="element-312">Involved Party</option>
            <option value="Supervisor" data-id="element-313">Supervisor</option>
            <option value="Colleague" data-id="element-314">Colleague</option>
            <option value="Management" data-id="element-315">Management</option>
            <option value="Other" data-id="element-316">Other</option>
          </select>
        </div>

        <Input label="Contact Information" placeholder="Email, phone, or desk location" value={formData.contact} onChange={e => setFormData({
        ...formData,
        contact: e.target.value
      })} data-id="element-317" />

        <Input multiline label="Notes" placeholder="Any additional context about this person..." value={formData.notes} onChange={e => setFormData({
        ...formData,
        notes: e.target.value
      })} data-id="element-318" />
      </div>
    </Modal>;
}